import * as React from 'react';
import * as styles from './TimeStreamMiniMap.scss';
import { getRenderingOrder, getSelectedProjectId } from 'owa-timestream-store';
import { observer } from 'mobx-react-lite';
import TimeStreamMiniMapAsset from './TimeStreamMiniMapAsset';

export default observer(function TimeStreamMinimapAssets() {
    const projectId = getSelectedProjectId();
    return (
        <g className={styles.assets}>
            {getRenderingOrder(projectId).map(assetId => (
                <TimeStreamMiniMapAsset key={assetId} projectId={projectId} assetId={assetId} />
            ))}
        </g>
    );
});
